import { render, staticRenderFns } from "./FoodForm.vue?vue&type=template&id=a1a52f38&"
import script from "./FoodForm.vue?vue&type=script&lang=js&"
export * from "./FoodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports